import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { emailValidator, InputComponent } from '@pc/input';
import { EmailQuoteText } from '@pc/shared';
import { BusinessUnit, PcButtonIcon } from '@pc/common';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { GradientBtnComponent } from '@pc/gradient-btn';
import { AlertCardComponent } from '@pc/alert-card';
import { EmailQuoteService } from '../../../../shared/services/quote/email-quote-service';
import { shortFadeOut } from '@pc/animations';
import { catchError, EMPTY, switchMap, tap, timer } from 'rxjs';
import { SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'pc-quote-overview-email',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, InputComponent, GradientBtnComponent, AlertCardComponent],
  templateUrl: './quote-overview-email.component.html',
  styleUrl: './quote-overview-email.component.scss',
  animations: [shortFadeOut],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuoteOverviewEmailComponent {
  public emailTexts = input.required<EmailQuoteText>();
  public privacyPolicyLink = input.required<SafeHtml>();
  public isBusy = signal<boolean>(false);
  public isAnimating = signal<boolean>(false);
  public showAlert = signal<boolean>(false);
  public PcButtonIcon = PcButtonIcon;
  public BusinessUnit = BusinessUnit;
  public emailQuoteForm!: FormGroup;
  private fb = inject(FormBuilder);
  private emailQuoteService = inject(EmailQuoteService);
  private readonly ALERT_DELAY = 5000;

  constructor() {
    this.initForm();
  }

  get email(): FormControl {
    return this.emailQuoteForm.controls['email'] as FormControl;
  }

  public submit(): void {
    if (this.emailQuoteForm.valid) {
      this.makeEmailQuote();
    }
  }

  public isButtonDisabled(): boolean {
    return this.email.value == '' || this.isBusy();
  }

  public onAnimationDone(): void {
    this.isAnimating.set(false);
  }

  private initForm(): void {
    this.emailQuoteForm = this.fb.group({
      email: ['', [emailValidator]]
    });
  }

  private makeEmailQuote(): void {
    this.isBusy.set(true);
    this.emailQuoteService
      .sendBasicQuoteDetails(this.email.value)
      .pipe(
        tap(() => {
          this.isBusy.set(false);
          this.showAlert.set(true);
        }),
        switchMap(() =>
          timer(this.ALERT_DELAY).pipe(
            tap(() => {
              this.isAnimating.set(true);
              this.showAlert.set(false);
            })
          )
        ),
        catchError(() => {
          this.isBusy.set(false);
          return EMPTY;
        })
      )
      .subscribe();
  }
}
